import styled from "styled-components";

export const Container = styled.div`
  max-width: 900px;
  margin: 0 auto;
  box-shadow: 3px 3px 6px darkgray, -3px -3px 6px darkgray;
`;